import {
  SET_IS_LOADING,
} from './types';

export const setIsLoading = bool => ({
  type: SET_IS_LOADING,
  payload: bool,
});

export default setIsLoading;